// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NDWq","colMin":"styles_colMin__1U8dj"};